import React from 'react';
import { Box } from '@mui/material';
import MarkdownRenderer from './MarkdownRenderer';
import EnhancedSkeleton from './EnhancedSkeleton';

const ChapterTabContent = ({ 
  detailContent, 
  formattedDetailContent, 
  isStreaming, 
  handleChapterClick, 
  scrollToChapter, 
  playerRef, 
  isMobile 
}) => {
  return (
    <>
      {Array.isArray(detailContent) && detailContent.length > 0 && (
        <MarkdownRenderer 
          content={formattedDetailContent}
          type="chapters"
          handleChapterClick={handleChapterClick}
          scrollToChapter={scrollToChapter}
          playerRef={playerRef}
          isMobile={isMobile}
        />
      )}
      
      {/* 챕터별 정리 로딩 애니메이션 - 스트리밍 중이면서 챕터 데이터가 없을 때만 표시 */}
      {isStreaming && (!detailContent || detailContent.length === 0) && (
        <Box sx={{ mt: 2 }}>
          {/* 목차 스켈레톤 */}
          <EnhancedSkeleton variant="text" height={28} width="30%" animationType="rainbow-wave" sx={{ mb: 2 }} />
          {Array.from({ length: 3 }).map((_, index) => (
            <EnhancedSkeleton key={index} variant="text" height={20} width="60%" animationType="power-pulse" sx={{ mb: 1, ml: 2 }} />
          ))}
          
          {/* 구분선 */}
          <Box sx={{ my: 3 }}>
            <EnhancedSkeleton variant="rectangular" height={1} width="100%" animationType="enhanced-wave" />
          </Box>
          
          {/* 챕터 내용 스켈레톤 */}
          {Array.from(new Array(2)).map((_, chapterIndex) => (
            <Box key={chapterIndex} sx={{ mb: 4 }}>
              <EnhancedSkeleton variant="text" height={24} width="70%" animationType="shimmer" sx={{ mb: 2 }} />
              {Array.from(new Array(3)).map((_, bulletIndex) => (
                <EnhancedSkeleton key={bulletIndex} variant="text" height={18} width="90%" animationType="gradient-flow" sx={{ mb: 1, ml: 1 }} />
              ))}
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};

export default ChapterTabContent; 